import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { initSessionResponder, tryHydrateSessionFromOtherTabs } from './auth/crossTabSession';

// Let other tabs ask this one for its session as soon as possible.
initSessionResponder();

async function bootstrap() {
  // Must finish before MSAL (or App's bypass check) reads sessionStorage,
  // so the session-aware modules are imported dynamically below.
  await tryHydrateSessionFromOtherTabs();

  const [{ MsalProvider }, { msalInstance }, { default: App }] = await Promise.all([
    import('@azure/msal-react'),
    import('./auth/msalConfig'),
    import('./App'),
  ]);

  const root = ReactDOM.createRoot(document.getElementById('root'));
  const app = <App />;

  root.render(
    <React.StrictMode>
      {msalInstance ? (
        <MsalProvider instance={msalInstance}>
          {app}
        </MsalProvider>
      ) : (
        app
      )}
    </React.StrictMode>
  );

  reportWebVitals();
}

bootstrap();
